"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var UnitFormatter = /** @class */ (function () {
    function UnitFormatter() {
        var _this = this;
        this.isoDateFormat = 'YYYY-MM-DD';
        this.isoFormatDate = function (date) {
            return moment_timezone_1.default.utc(date).local().format(_this.isoDateFormat);
        };
        this.formatNow = function () {
            return moment_timezone_1.default.utc().local().format('lll');
        };
        this.formatMonth = function (date) {
            return moment_timezone_1.default.utc(date).local().format('MMMM');
        };
        this.formatYearMonth = function (date) {
            return moment_timezone_1.default.utc(date).local().format('YYYY-MM');
        };
        this.formatDateShort = function (date) {
            return moment_timezone_1.default.utc(date).local().format('ddd MMM DD, YYYY');
        };
    }
    return UnitFormatter;
}());
exports.default = new UnitFormatter();
